import { Button, Form, Input, InputNumber, Modal, Select, message } from "antd";
import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { createGroupStock } from "../../services/groupConsole.service";
import reportCreateResult from "./reportCreateResult";
import useTargetSchools from "./useTargetSchools";

// Same lists AddEditStockItem.js (the branch admin's own Stock screen)
// offers, so a group admin sees identical choices.
const CATEGORIES = [
  "Stationery",
  "Furniture",
  "Cleaning",
  "Sports",
  "Lab",
  "Electronics",
  "Other",
];
const UNITS = ["piece", "box", "packet", "set", "pair", "kg", "litre", "metre"];

export default function CreateGroupStockModal({ groupId, open, onClose }) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();
  const { targetSchools, selectProps } = useTargetSchools();

  const close = () => {
    form.resetFields();
    onClose();
  };

  const createMutation = useMutation(
    (payload) => createGroupStock(groupId, payload),
    {
      onSuccess: (result) => {
        reportCreateResult(result, "Item");
        queryClient.invalidateQueries("group-console-stock");
        close();
      },
      onError: (err) => {
        message.error(
          err?.response?.data?.error?.errors?.[0] || "Failed to create item",
        );
      },
    },
  );

  const onFinish = (values) => {
    createMutation.mutate({ ...values, targetSchools });
  };

  return (
    <Modal
      title="Create Stock Item"
      open={open}
      onCancel={close}
      footer={null}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ unit: "piece", quantity_in_hand: 0, low_stock_threshold: 0 }}
      >
        <Form.Item label="Post to" required>
          <Select style={{ width: "100%" }} {...selectProps} />
        </Form.Item>

        <Form.Item
          name="name"
          label="Item name"
          rules={[{ required: true, message: "Enter an item name" }]}
        >
          <Input placeholder="e.g. Chalk (box)" />
        </Form.Item>

        <div className="flex gap-4">
          <Form.Item name="category" label="Category" className="flex-1">
            <Select allowClear placeholder="Select category">
              {CATEGORIES.map((c) => (
                <Select.Option key={c} value={c}>
                  {c}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="unit" label="Unit" className="flex-1">
            <Select>
              {UNITS.map((u) => (
                <Select.Option key={u} value={u}>
                  {u}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </div>

        <div className="flex gap-4">
          <Form.Item name="quantity_in_hand" label="Opening stock" className="flex-1">
            <InputNumber className="w-full" min={0} />
          </Form.Item>
          <Form.Item name="low_stock_threshold" label="Low stock threshold" className="flex-1">
            <InputNumber className="w-full" min={0} />
          </Form.Item>
        </div>

        <Form.Item name="description" label="Description">
          <Input.TextArea rows={3} />
        </Form.Item>

        <div className="flex justify-end gap-2 pt-4 border-t">
          <Button onClick={close}>Cancel</Button>
          <Button type="primary" htmlType="submit" loading={createMutation.isLoading}>
            Create
          </Button>
        </div>
      </Form>
    </Modal>
  );
}
